import asyncTreeRequester from 'utility/asyncTreeRequester';
import { get, uniqBy } from 'lodash';
import tree from 'state';
import * as effects from './effects';
import formatData from './transformer';

const contentCursor = tree.select(['content']);

export async function getCategories() {
  const results = await asyncTreeRequester({
    func: effects.getCategories.bind(this),
    cursor: contentCursor,
    path: ['categories'],
  });
  return results;
}

export async function getContent(id) {
  const result = await asyncTreeRequester({
    func: effects.getContent.bind(this, id),
    cursor: contentCursor,
    path: ['details', id],
  });
  return result;
}

export async function clearContent() {
  contentCursor.set('list', {});
}

export async function getContentList({
  filters = {},
  pagination = {},
  sorting = {},
  appendResults,
} = {}) {
  const contentResult = await asyncTreeRequester({
    func: effects.getContentList.bind(this),
    pagination,
    filters,
    sorting,
    cursor: contentCursor,
    path: ['list'],
    transformer({ result, cursor }) {
      const currentResult = result || {};
      if (appendResults !== false) {
        currentResult.docs = uniqBy(
          [...get(cursor, 'result.docs', []), ...result.docs],
          'id'
        );
      }
      return currentResult;
    },
  });

  return contentResult;
}

export async function getSimilarContent(
  id,
  { filters = {}, pagination = {}, sorting = {} } = {}
) {
  const result = await asyncTreeRequester({
    func: effects.getSimilarContentList.bind(this, id),
    pagination,
    filters,
    sorting,
    cursor: contentCursor,
    path: ['similar'],
  });
  return result;
}

export async function patchContent(id, data) {
  const formattedData = formatData(data);
  try {
    contentCursor.set(['details', id, 'saving'], true);
    const _patchContent = await effects.patchContent(id, formattedData);
    contentCursor.set(['details', id], {
      saving: false,
      result: _patchContent,
    });
    return _patchContent;
  } catch (err) {
    contentCursor.set(['details', id, 'saving'], false);
    return { error: err.message };
  }
}

export async function addContent(data) {
  const formattedData = formatData(data);
  try {
    const addedContent = await effects.addContent(formattedData);
    return addedContent;
  } catch (err) {
    return { error: err.message };
  }
}

export async function updateStatus(id, status) {
  try {
    const statusChange = await effects.updateStatus(id, status);
    contentCursor.merge(['details', id, 'result'], statusChange);
    return statusChange;
  } catch (err) {
    return { error: err.message };
  }
}
